import React from 'react';
import { FOOTER_LINKS, LOGO_URL } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/8">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-7">
              <img src={LOGO_URL} alt="SAMZ Academy" className="h-10 w-10 object-contain" />
              <span className="font-display text-white text-[18px] tracking-wide">SAMZ Academy</span>
            </div>
            <p className="text-white/55 text-[14.5px] leading-[1.7] max-w-[420px] mb-8">
              The Empowerment Zone for Creatives. Talent is everywhere. Opportunity is not. SAMZ closes the gap.
            </p>
            <a href="#signup" className="btn-jade !text-[13.5px] !py-2.5 !px-4">
              Sign Up <ArrowUpRight size={15} />
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8">
            {Object.entries(FOOTER_LINKS).map(([title, items]) => (
              <div key={title}>
                <div className="pin-num mb-5 !text-[10px]">{title}</div>
                <ul className="space-y-3">
                  {items.map((it) => (
                    <li key={it}>
                      <a href="#" className="footer-link text-[13.5px]">{it}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Giant wordmark */}
        <div className="py-10 border-t border-white/8 overflow-hidden">
          <div className="font-display text-[18vw] lg:text-[14vw] leading-[0.85] tracking-[-0.05em] text-transparent select-none"
               style={{ WebkitTextStroke: '1px rgba(34,167,115,0.45)' }}>
            SAMZ ACADEMY
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/8">
          <div className="text-white/45 text-[12.5px] tracking-[0.05em]">
            © {new Date().getFullYear()} SAMZ. The Empowerment Zone for Creatives. <a href="https://www.samzapp.com" className="footer-link">www.samzapp.com</a>
          </div>
          <div className="flex items-center gap-6 text-[12.5px] text-white/45">
            <a href="#" className="footer-link">Privacy</a>
            <a href="#" className="footer-link">Terms</a>
            <a href="#" className="footer-link">Trust Center</a>
            <a href="#" className="footer-link">Status</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
